/**
 * Core
 */
import React from "react";
/**
 * Styles
 */
import "./InputGlobal.scss";

function InputGlobal({
  placeholder,
  className,
  name,
  type,
  onChange,
  id,
  value,
  autoComplete,
  onBlur,
  onFocus,
}) {
  return (
    <input
      autoComplete={autoComplete ? autoComplete : "off"}
      type={type}
      placeholder={placeholder}
      className={className}
      name={name}
      onChange={onChange}
      id={id}
      value={value}
      onBlur={onBlur}
      onFocus={onFocus}
    />
  );
}

export default InputGlobal;
